<template>
  <div class="pb-20">
    <Listbox v-if="filtered_result_references.length" v-model="selected_result_reference" as="div" class="relative flex-1">
      <div class="relative h-full">
        <ListboxLabel
          class="block text-base font-medium text-gray-700 dark:text-dark-body-text bg-light-box-background dark:bg-dark-box-background"
          :for="name">
          {{ $t("Select Records List to loop through") }}:
        </ListboxLabel>
        <ListboxButton
          class="relative w-full h-full py-1 pl-2 pr-10 overflow-hidden text-left bg-white border rounded-md cursor-default focus:ring-dark-brand-blue dark:focus:ring-dark-brand-blue focus:border-dark-brand-blue dark:focus:border-dark-brand-blue dark:bg-dark-screen-background border-light-divider-border dark:border-dark-divider-border focus:outline-none">
          <span v-if="selected_result_reference"
                class="block py-1 truncate text-thin text-light-body-text dark:text-dark-body-text">{{ selected_result_reference?.name }}
            {{ selected_result_reference.object_to_extract_label ? selected_result_reference.object_to_extract_label : null }}
          </span>
          <span v-else class="block py-1 truncate text-thin text-common-grey dark:text-dark-body-text">{{
            $t("Records List Reference")
          }}</span>
          <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
            <ChevronDown class="w-5 h-5 text-gray-400" aria-hidden="true" />
          </span>
        </ListboxButton>

        <transition leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100" leave-to-class="opacity-0">
          <ListboxOptions
            class="absolute z-50 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg min-w-max dark:bg-dark-screen-background max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none text-light-body-text dark:text-dark-body-text">
            <ListboxOption
              v-for="option in filtered_result_references"
              :key="option.value"
              v-slot="{ active, selected }"
              as="template"
              :value="option">
              <li
                :class="[
                  active ? 'text-white bg-blue' : 'text-light-body-text dark:text-dark-body-text',
                  'cursor-default relative py-2 pl-5 pr-4 text-left'
                ]">
                <span :class="[selected ? 'font-semibold' : 'font-normal', 'block truncate']">
                  {{ option?.name }} {{ option.object_to_extract_label ? option.object_to_extract_label : null }}
                </span>

                <span v-if="selected" :class="[active ? 'text-white' : 'text-blue', 'absolute inset-y-0 left-0 flex items-center pl-1.5']">
                  <Check class="w-5 h-5" aria-hidden="true" />
                </span>
                <div class="flex-wrap p-2 text-white bg-gray-700 rounded tooltip whitespace-nowrap">
                  {{ option?.name }} {{ option.object_to_extract_label ? option.object_to_extract_label : null }}
                </div>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>

    <div v-else>
      {{ $t("There are no results to loop through, add a records filter or activities filter component first") }}
    </div>
  </div>
</template>

<script>
import { Listbox, ListboxLabel, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/vue"
import { ChevronDown, Check } from "lucide-vue-next"

export default {
  components: {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
    ChevronDown,
    Check
  },
  props: { selectedNode: null, previousLabels: null, allLabels: null },
  emits: ["updateValues"],
  data() {
    return {
      selected_result_reference: null
    }
  },

  computed: {
    filtered_result_references() {
      const list_calc = []
      this.previousLabels.forEach((l) => {
        list_calc.push(l)
      })

      return list_calc.map((l) => {
        return { ...l, value: `\${${this.$utils.slugify(l.name)}${l.object_to_extract ? `.${l.object_to_extract}` : ``}}` }
      })
    }
  },
  watch: {
    selected_result_reference: {
      deep: true,
      handler() {
        this.handleUpdateValues()
      }
    }
  },

  created() {
    this.init()
  },
  methods: {
    init() {
      this.selected_result_reference = this.filtered_result_references.find((r) => r.value == this.selectedNode.data.values.records)
    },
    handleUpdateValues() {
      let valid_calc = true

      if (!this.selected_result_reference) {
        valid_calc = false
      }

      const data = {
        ...this.selectedNode.data.values,
        records: this.selected_result_reference?.value,
        valid: valid_calc
      }
      this.$emit("updateValues", data)
    }
  }
}
</script>
